var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18992",
    "data-name": "Rectangle 18992",
    width: 30,
    height: 30,
    rx: 6,
    transform: "translate(55 388)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Low_Priority",
    "data-name": "Low Priority",
    transform: "translate(-55 -388)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    transform: "translate(55.001 388.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10274",
    "data-name": "Group 10274",
    transform: "translate(0.999 20.249) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43666",
    "data-name": "Path 43666",
    d: "M1.8,28.34a1.8,1.8,0,0,1-1.431-2.9L9,14.171.372,2.9A1.8,1.8,0,1,1,3.235.709l9.472,12.365a1.8,1.8,0,0,1,0,2.192L3.235,27.632A1.794,1.794,0,0,1,1.8,28.34Z",
    fill: "#965ec7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPriority);
export default __webpack_public_path__ + "static/media/lowPriority.e7686264f2592377dbbf681a8c4428f2.svg";
export { ForwardRef as ReactComponent };